import { render, staticRenderFns } from "./InterviewReview.vue?vue&type=template&id=2f6cf997&scoped=true"
import script from "./InterviewReview.vue?vue&type=script&lang=js"
export * from "./InterviewReview.vue?vue&type=script&lang=js"
import style0 from "./InterviewReview.vue?vue&type=style&index=0&id=2f6cf997&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f6cf997",
  null
  
)

export default component.exports